/*
FEATURE: shade-finder         STATUS: optional
COST: 5,731 B CSS + 13,961 B JS (when enabled)
PROVIDES: Custom Findation API v2 shade-matching drawer on eligible PDPs
REQUIRES: Findation merchant product URL and Shopify variant External IDs
HOOKS: sections/main-product.liquid
SETTINGS: settings.enable_shade_finder
REMOVE: docs/optional-features/shade-finder.md
*/
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {
	ShadeFinder,
	ShadeFinderOpener,
} from '@/scripts/optional/shade-finder'

q.safeDefineElement(ShadeFinder)
q.safeDefineElement(ShadeFinderOpener)

const shadeFinderHash = '#find-my-shade'

function openLinkedShadeFinder(opener: HTMLElement): void {
	q.os<ShadeFinder>('shade-finder')?.show(opener)
}

document.addEventListener('click', (event) => {
	const target = event.target
	if (!(target instanceof Element)) return
	const link = target.closest<HTMLAnchorElement>(`a[href="${shadeFinderHash}"]`)
	if (!link) return
	event.preventDefault()
	openLinkedShadeFinder(link)
})

window.addEventListener('hashchange', () => {
	if (window.location.hash === shadeFinderHash) openLinkedShadeFinder(document.body)
})

if (window.location.hash === shadeFinderHash) {
	window.requestAnimationFrame(() => openLinkedShadeFinder(document.body))
}
